<template>
  <div>
    <c-input
      v-model="localValue"
      type="price-number"
      :required-mark="field.required"
      :floating-label="field.name"
      :clearable="true"
      :required="error"
      :required-condition="error"
      :allow-negative="true"
      :fractional-length="Infinity"
    />
  </div>
</template>

<script>
import CInput from "@/components/controls2/Input";

export default {
  components: { CInput },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      localValue: "",
    };
  },
  watch: {
    localValue(v) {
      this.$emit("input", { value: v });
      if (this.inited) this.$emit("change");
    },
    value(v) {
      this.setData(v);
    },
  },

  created() {
    if (this.value) this.setData(this.value);
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;
      this.localValue = value.value;
      this.$nextTick(() => {
        this.inited = true;
      });
    },
  },
};
</script>
